import React from 'react';
import { Stack, IconButton } from '@mui/material';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';

import { TicketCompany, getTicketCompanyDetails } from '../../../../domain/tickets';
import { TravelPoints } from '../../../../domain/travels';

import { TravelPointLabel } from './travel-point-label';

/* === TICKET TRAVEL POINTS SWITCH PROPS =============================================== */
interface Props {
  origin: TicketCompany;
  destination: TicketCompany;
  onSwitch: (travelPoints: TravelPoints<TicketCompany>) => void;
}

export const TicketTravelPointsSwitch = ({ origin, destination, onSwitch }: Props) => {
  /* === HANDLERS ===================================================================== */
  const handlePointsSiwtch = () => {
    onSwitch({ origin: destination, destination: origin });
  };

  /* === RENDER ======================================================================= */
  return (
    <Stack position="relative" direction="row" gap="22px">
      <TravelPointLabel label={getTicketCompanyDetails(origin).place} isOrigin />

      <IconButton
        sx={{
          top: '11px',
          left: '112px',
          width: '40px',
          height: '28px',
          border: '1px solid rgba(186, 186, 186, 0.30)',
          position: 'absolute',
          borderRadius: '8px',
          backgroundColor: '#FFF',
          '&:hover': {
            backgroundColor: '#FFF',
          },
        }}
        onClick={handlePointsSiwtch}
      >
        <CompareArrowsIcon fontSize="medium" sx={{ color: '#EF60A3' }} />
      </IconButton>

      <TravelPointLabel label={getTicketCompanyDetails(destination).place} />
    </Stack>
  );
};
